import ApplicationController from '../application_controller.js'

/*
 * Cfile transfert
 */

export default class TransferController extends ApplicationController {

  select_operation(e) {
    this.visit(e.target.value)
  }

  step1_reload(e) {
    this.visit(`${e.target.dataset.path}&client_id=${e.target.value}`)
  }

}